<template>
        <div id='alterloginpsw'>
              <NavTop title='修改登陆密码'/>
              <div class='content'>
                 <div class="row">
                      <div class="label">验证码</div>
                      <div class="maininput"><input placeholder="请输入验证码" type='number' v-model="code"/></div>
                      <div class="yzm_btn" @click="getCode(4)">获取验证码</div>
                 </div>
                 <div class="row">
                       <div class="label">新密码</div>
                       <div class="maininput"><input placeholder="请输入新密码" type="password" v-model='password'/></div>
                 </div>
                 <div class="row">
                  <div class="label">确认新密码</div>
                  <div class="maininput"><input placeholder="请再次输入新密码" type="password" v-model='repassword'/></div>
                 </div>
                 <div class="submitbtn_out">
                        <div class="submitbtn" @click="saveNewPassword">提交</div>
                 </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
         mobile:'',
         password:'',
         repassword:'',
         code:''
      }
  },  
  name: 'alterloginpsw',
  created(){
      this.getList()
  },
  methods:{
    getList(){
        this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
              this.mobile=data.result.info.mobile
            }
        })
    },
    getCode(type){
         if(this.mobile==''|| isNaN(this.mobile)){
            this.$toast("手机号码不正确")
            return false
         } 
         this.$post("/sms/getCode",{mobile:this.mobile,type:type}).then((data)=>{
              this.$toast(data.result.info)
         })
    },
    saveNewPassword(){
        if(this.password==""||this.repassword==""){
            this.$toast("密码不能为空");return false;
        }
        if(this.password!=this.repassword){
          this.$toast("两次密码输入不一致");return false;
        }
        if(this.code==""){
          this.$toast("验证码不能为空");return false;
        }
        this.$post("/user/alterLoginPsw",{code:this.code,mobile:this.mobile,password:this.password,repassword:this.repassword}).then((data)=>{
             if(data.result.success){
                this.$toast(data.result.info)
                this.$store.dispatch("doLogout")
                setTimeout(()=>{
                  this.$go("/login")
                },1500)
             }else{
                this.$toast(data.result.info)
             }
        })
    }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#alterloginpsw{background-color:#F6F6F6;min-height: 100vh;}
.content{display: flex;flex-flow: column nowrap;padding: 0.35rem;background-color: #fff;border-radius: 0.2rem;margin: 0 0.25rem;}
.title{font-size:0.5rem;padding: 0.35rem;text-align: left;padding-left: 0.15rem;}
.row{display: flex;flex-flow:row nowrap;border-bottom: 1px solid #e7e7e7;align-items: center;padding: 0.35rem;}
.label{width:2.2rem;text-align: left;font-size:0.35rem;}
.maininput {flex:1 0 50%;}
.maininput input{border: none;outline: none;color:#333;background-color: #fff;width: 100%;font-size:0.35rem;}
.yzm_btn{text-decoration: underline;font-size:0.3rem;color:#333;}
.submitbtn_out{margin-top: 0.65rem;}
.submitbtn{background-color:#ee0a24;color:#fff;;font-size:0.35rem;padding: 0.25rem;border-radius: 0.1rem;}

</style>


